module.exports = __webpack_public_path__ + "static/media/sky-logo.a88555fc.png";